import { useState } from 'react';
import { CellContext, createColumnHelper } from '@tanstack/react-table';
import { FileText } from 'lucide-react';

import { DescribeModal } from '@/react/kubernetes/components/DescribeModal/DescribeModal';

import { Button } from '@@/buttons';
import { Icon } from '@@/Icon';

import { CustomResource } from '../../types';

const columnHelper = createColumnHelper<CustomResource>();

export const actions = columnHelper.display({
  id: 'actions',
  header: 'Actions',
  cell: Cell,
});

function Cell({ row }: CellContext<CustomResource, unknown>) {
  const { name, namespace, definitionName } = row.original;
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Button
        color="link"
        onClick={() => setModalOpen(true)}
        className="pl-0 !ml-0"
        data-cy="custom-resource-describe"
      >
        <Icon icon={FileText} />
        Describe
      </Button>

      {modalOpen && (
        <DescribeModal
          name={name}
          resourceType={definitionName}
          namespace={namespace}
          onDismiss={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
